import styled from 'styled-components';

import HTMLContent from '@telialt/common-html-content/src';
import { getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const SummaryContent = styled(HTMLContent)`
    margin-bottom: ${getPurpurSpacing('600')};
`;
